/**
 * CommandPaletteLauncher (PR_RUN_035)
 * ====================================
 * Topbar "Jump to..." button. Consumes the CommandPaletteContext to open
 * the global ⌘K palette, replacing the prior `window.__openCommandPalette`
 * global from PR_RUN_031.
 */
import { Search } from "lucide-react";
import { useCommandPalette } from "../contexts/CommandPaletteContext";

const CommandPaletteLauncher = () => {
  const { openPalette } = useCommandPalette();
  return (
    <button
      type="button"
      onClick={openPalette}
      className="hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#1E3A5F] bg-[#0F1E35] text-slate-400 hover:text-white hover:border-[#00C8E0] text-xs transition-colors"
      data-testid="command-palette-launch-btn"
      aria-label="Open command palette (Cmd+K)"
      title="Quick jump · ⌘K"
    >
      <Search size={13} />
      <span>Jump to…</span>
      <kbd className="ml-1 px-1.5 py-0.5 rounded bg-[#1E3A5F] text-[10px] font-mono">⌘K</kbd>
    </button>
  );
};

export default CommandPaletteLauncher;
